import React__default, { useEffect } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { FormControl } from '@sravni/react-design-system/lib/FormControl';
import { Space } from '@sravni/react-design-system/lib/Space';
import { TextInput } from '@sravni/react-design-system/lib/TextInput';
import { useStyles, useIsMobile, useIsTablet, useIsAppleMobile, mergeRefs } from '@sravni/react-utils';
import { TOO_MANY_REQUESTS_ERROR_TYPE } from '../../constansts/index.js';
import { convertMillisecondsToHumanString } from '../../helpers/time.js';
import { useClearErrorWithDelay } from '../../hooks/useClearErrorWithDelay.js';
import '../ContextProvider/components/IsLoadingProvider/provider.js';
import { useIsLoading } from '../ContextProvider/components/IsLoadingProvider/hook.js';
import '../ContextProvider/components/IsOTPSendedProvider/provider.js';
import { useIsOTPSended } from '../ContextProvider/components/IsOTPSendedProvider/hook.js';
import modules_13b53a7e from './styles.module.less.js';

const INPUT_NAME = "code" /* FIELD_NAME.OTP */;
const DEFAULT_LABEL = 'Код из смс';
const OTPInput = React__default.forwardRef((props, ref) => {
    const { label = DEFAULT_LABEL, underInputComponent, ...restProps } = props;
    const cx = useStyles(modules_13b53a7e);
    const { control, setFocus, formState: { errors }, } = useFormContext();
    const [isLoading] = useIsLoading();
    const [isOTPSended] = useIsOTPSended();
    const isMobile = useIsMobile();
    const isTablet = useIsTablet();
    const isAppleMobile = useIsAppleMobile();
    const [errorMessageShowTime] = useClearErrorWithDelay({ inputName: INPUT_NAME });
    const error = errors[INPUT_NAME];
    useEffect(() => {
        // НА touch устройствах - установках фокуса в инпут НЕ вызывает появление клавиатуры. В результате кривой ux
        if (isMobile || isTablet)
            return;
        if (isOTPSended)
            setFocus(INPUT_NAME);
    }, [setFocus, isOTPSended, isMobile, isTablet]);
    return (React__default.createElement(FormControl, { invalid: !!error },
        React__default.createElement(Space, { direction: "vertical" },
            React__default.createElement(Controller, { name: INPUT_NAME, control: control, render: ({ field }) => (React__default.createElement(TextInput, { ...field, ...restProps, 
                    // Для открытия цифровой клавиатуры на мобиле
                    inputMode: "decimal", readOnly: isLoading, label: label, ref: mergeRefs(field.ref, ref), 
                    // Apple говнокуски и сабмитят форму автоматом при автозаполенении поля. и сами же не считаю это безопастным действием.
                    // изза этого блочится открытие вспылающего окна
                    autoComplete: isAppleMobile ? 'off' : 'one-time-code' })) }),
            React__default.createElement(FormControl.HelperText, null,
                error?.message,
                typeof error?.type === 'string' && error.type.includes(TOO_MANY_REQUESTS_ERROR_TYPE)
                    ? ` ${convertMillisecondsToHumanString(errorMessageShowTime)}`
                    : ''),
            underInputComponent ? React__default.createElement("span", { className: cx('actions') }, underInputComponent) : null)));
});

export { OTPInput };
//# sourceMappingURL=view.js.map
